import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    > button {
      display: none;
    }
  }

  .predefined-dates {
    background-color: initial;
    cursor: pointer;
    padding: 1rem 2rem;
    color: #17a2b8;
    font-weight: 500;
    font-size: 1.5rem;
    border-radius: 5px;
    transition: all 0.2s;
    margin-right: 12px;
    border: 2px solid transparent;
    opacity: 0.8;
  }

  .predefined-dates:not(:last-child):hover,
  .selected {
    border: 2px solid #17a2b8;
    opacity: 1;
  }

  #custom-datepicker:not(.custom-selected) {
    opacity: 0.8;
  }

  .DateRangePickerInput > div:not(:first-child) {
    display: none;
  }

  .DateRangePickerInput button {
    width: fit-content;
    height: fit-content;
    margin: 0;
    padding: 0;
    transition: all 0.2s;
  }

  .DateRangePickerInput button svg {
    stroke: #17a2b8;
  }

  .DateRangePickerInput {
    background: none;
  }
`
